import {IoCartOutline, IoChevronDown, IoHeart, IoPersonOutline} from "react-icons/io5";
import React from "react";
import {useTranslation} from "react-i18next";

const MobileMainScreen = ({
                                headerFont, bodyFont, backgroundColor, contentColor, iconsColor, buttonColor, cardColor, viewportHeight
                            }) => {
    const { t } = useTranslation()
    return (
        <div className="relative">

            <div className="absolute" style={{ width: '100%', height: `${viewportHeight}px`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundColor: `${backgroundColor}`}}>
                <div className="navbar flex justify-between"
                     style={{ padding: '2vw'}}>
                    <div></div>
                    <span style={{fontSize: '4vw', color: `${contentColor}`}} className="flex items-center">
                        {t('Restaurant name')}
                                    <IoChevronDown style={{ marginTop: '5px'}} />
                                </span>
                    <div style={{
                        fontSize: '4vw'
                    }}><IoPersonOutline color={iconsColor} /></div>
                </div>
                <div className="order-type flex bg-gray-200 rounded-md" style={{marginLeft:'4vw', marginRight:'4vw'}}>
                    <div className="bg-white rounded-md text-center w-1/2"
                         style={{ margin: '0.5vw', fontSize: '2.5vw', padding: '1vw', backgroundColor: `${cardColor}`, color: `${contentColor}`}}>{t('Dine-in')}</div>
                    <div className="w-1/2 text-center" style={{ margin: '0.5vw', fontSize: '2.5vw', padding: '1vw', color: `${contentColor}`}}>{t('Pick-up')}</div>
                </div>

                <div className="favorites" style={{ marginTop:'1vh', marginLeft: '4vw', marginRight: '4vw'}}>
                    <div className="font-bold" style={{ fontSize: '5vw', color: `${contentColor}`}}>{t('FAVORITES')}</div>
                    <div className="flex rounded-md" style={{ backgroundColor: `${cardColor}`}}>
                        <div className="flex">
                            <img className="w-1/3 rounded-l" src="/images/sample_dish.jpeg" alt=""/>
                            <div style={{
                                     marginTop: '1vh',
                                     marginLeft: '1vw',
                                     fontSize: '3vw', color: `${contentColor}` }}>Avobar Guac & chips</div>
                        </div>
                        <div style={{
                            marginTop: '1vh',
                            marginRight: '3vw',
                            fontSize: '4vw',
                        }}><IoHeart color='#F44336' /></div>
                    </div>

                    <div className="flex">
                        <div className="bg-gray-500 rounded-md w-1/2" style={{ height: '0.5vh', marginTop: '0.5vh', marginRight: '0.5vw'}} />
                        <div className="bg-gray-300 rounded-md w-1/2" style={{ height: '0.5vh', marginTop: '0.5vh', marginLeft: '0.5vw'}} />
                    </div>
                </div>

                <div className="favorites mt-1" style={{ marginLeft:'4vw', marginRight:'4vw'}}>
                    <div className="font-bold" style={{ fontSize: '5vw', color: `${contentColor}`}}>{t('SPECIAL OFFERS')}</div>
                    <div className="flex bg-white rounded-md">
                        <div className="flex">
                            <img className="w rounded-md" src="/images/sample_banner.png" alt=""/>
                        </div>
                    </div>

                    <div className="flex">
                        <div className="bg-gray-500 rounded-md " style={{ height: '1vh', marginTop: '2vh'}} />
                    </div>
                </div>

                <div className="favorites" style={{ marginLeft:'4vw', marginRight:'4vw'}}>
                    <div className="font-bold" style={{ fontSize: '5vw', color: `${contentColor}`}}>START WITH</div>
                    <div className="grid grid-cols-2 gap-2">
                        <div className="rounded-md " style={{ backgroundColor: `${cardColor}`}}>
                            <img className=" rounded-t" src="/images/sample_dish2.png" alt=""/>
                            <div style={{ fontSize: '3vw', margin: '2vw', color: `${contentColor}`}}>Avo egg Salad</div>
                        </div>
                        <div className="rounded-md " style={{ backgroundColor: `${cardColor}`}}>
                            <img className=" rounded-t" src="/images/sample_dish.jpeg" alt=""/>
                            <div style={{ fontSize: '3vw', margin: '2vw', color: `${contentColor}`}}>Avobar Guac & Chips</div>
                        </div>
                    </div>

                </div>


                <div className="footer flex w-full"
                     style={{
                         paddingLeft:'3.5vw',
                         paddingRight:'3.5vw',
                         position:'absolute',
                         bottom: '2vh',
                         fontSize: '8vw',
                         marginBottom: 10
                     }}>
                    <div className="w-full flex justify-between"
                         style={{
                             borderRadius: '5vw',
                             paddingTop: '1vh',
                             paddingBottom:' 1vh',
                             backgroundColor: `${buttonColor}` }}>
                        <div className="bg-gray-100 rounded-full flex justify-center items-center"
                             style={{
                                 marginLeft:'2vw',
                                 width: '7vw',
                                 height: '7vw',
                                 fontSize: '5vw',
                                 paddingLeft: '0.5vw',
                                 color: `${contentColor}`,
                                 backgroundColor: `${backgroundColor}`}}>1</div>
                        <div className="font-bold" style={{ fontSize: '5vw', color: `${contentColor}`}}>Review order</div>
                        <div style={{
                            marginRight: '2vw',
                            fontSize: '5vw',
                            color: `${contentColor}`
                        }}>£7.00</div>
                    </div>
                </div>
                <div style={{
                    position:'absolute',
                    bottom: '10vh',
                    right:'4vw',
                    fontSize: '8vw',
                    backgroundColor: `${buttonColor}`,
                    width: '15vw',
                    height: '15vw',
                }}
                     className="rounded-full w-9 h-9 flex justify-center items-center shadow-md">
                    <IoCartOutline />
                </div>
            </div>
        </div>
    )
}

export default MobileMainScreen
